module.exports = __webpack_public_path__ + "img/add-user.61efde09.png";